<template>
  <div class="dettaglio-quotazione" v-loading="loading">
    <div class="header-tab row row-custom">
      <div class="col-2 back-div">
        <icon name="riv-arrow" scale="3" class="back pointer" flip="horizontal" @click.native="goBack" />
      </div>
      <div class="col-20">
        <div class="my-label col-24 no-padding">
          {{ $t('dettaglioQuotazione.quotazione').toUpperCase() + ' ' + quotazione.numRif }}
        </div>
        <div class="sotto-label col-24 no-padding">
          {{ '(' + $t('dettaglioQuotazione.del') + ' ' }}{{ moment(quotazione.dataRicez, 'DDMMYYYY').format('DD/MM/YYYY') }}{{ quotazione.dataInvio ? (' - ' + $t('dettaglioQuotazione.inviataIl') + ' ' + moment(quotazione.dataInvio, 'DDMMYYYY').format('DD/MM/YYYY') + ')') : ')' }}      
        </div>
      </div>
    </div>
    <div class="row row-custom">
      <div class="sx col-xl-16 col-24">
        <div class="descrizione col-24 no-padding">
          {{ quotazione.desc + ' (' + quotazione.tipoRich + ' - ' + quotazione.descRich + ')' }}
          <el-tooltip class="item" effect="dark" :content="$t('dettaglioQuotazione.note')" placement="top">
            <icon name="riv-addnotes" scale="1.5" class="pointer" @click.native="goToNote(false)" />
          </el-tooltip>
        </div>
        
        <div class="row row-custom">
          <div class="testata-sx col-xl-12 col-lg-12 col-md-18 col-sm-20 col-22" style="margin-bottom: 0">
            <div class="row row-custom elemento">
              <div class="testata-label col-10">
                {{ $t('dettaglioQuotazione.dataScadenza') }}
              </div>
              <div class="testata-value col-14 no-padding">
                {{ (testata.dataScad) ? moment(testata.dataScad, 'DDMMYYYY').format('DD/MM/YYYY') : '' }}
              </div>
            </div>
            <div class="row row-custom elemento">
              <div class="testata-label col-10">
                {{ $t('dettaglioQuotazione.tecnico') }}
              </div>
              <div class="testata-value col-14 no-padding">
                {{ testata.descTecn }}
              </div>
            </div>
            <div class="row row-custom elemento">
              <div class="testata-label col-10">
                {{ $t('dettaglioQuotazione.impUfficioAcquisti') }}
              </div>
              <div class="testata-value col-14 no-padding">
                {{ testata.descImpUA }}
              </div>
            </div>
          </div>
        </div>    
        <div class="row row-custom">
          <div class="testata-sx col-xl-12 col-lg-12 col-md-18 col-sm-20 col-22">
            <div class="row row-custom elemento">
              <div class="testata-label col-10">
                {{ $t('dettaglioQuotazione.vsRif') }}
              </div>
              <div class="testata-value col-14 no-padding">
                <el-input v-model="testata.rifForn" :maxlength="20" class="custom-input" :disabled="disabled" />
              </div>
            </div>
            <div class="row row-custom elemento">
              <div class="testata-label col-10">
                {{ $t('dettaglioQuotazione.del') }}
              </div>
              <div class="testata-value col-14 no-padding">
                <el-date-picker
                  :disabled="disabled"
                  v-model="testata.dataRif"
                  type="date" format="dd/MM/yyyy" value-format="ddMMyyyy"
                  placeholder="" class="custom-date-picker"
                  :picker-options="{firstDayOfWeek: 1}"
                />
              </div>
            </div>
            <div class="row row-custom elemento">
              <div class="testata-label col-10">
                {{ $t('dettaglioQuotazione.validaFino') }}
              </div>
              <div class="testata-value col-14 no-padding">
                <el-date-picker 
                  :disabled="disabled"
                  v-model="testata.dataVal"
                  type="date" format="dd/MM/yyyy" value-format="ddMMyyyy"
                  placeholder="" class="custom-date-picker"
                  :picker-options="{firstDayOfWeek: 1}"
                />
              </div>
            </div>
            <div class="row row-custom elemento" v-if="testata.ifInterventi !== 'Y'">
              <div class="testata-label col-10">
                {{ $t('dettaglioQuotazione.consegna') }}
              </div>
              <div class="consegna no-padding">
                <el-input v-model="testata.numSettCons" :maxlength="3" class="custom-input" :disabled="disabled" @focus="focusInterventi" />
              </div>
              <div class="consegna-label-dx">
                {{ '(' + $t('dettaglioQuotazione.settimaneDaOrdine') + ')' }}
              </div>
            </div>
            <div class="row row-custom elemento">
              <div class="testata-label col-10">
                {{ $t('dettaglioQuotazione.resa') }}
              </div>
              <div class="col-14 textarea no-padding">
                <el-input v-model="testata.resa" type="textarea" resize="none" class="custom-input" :maxlength="100" :disabled="disabled" />
              </div>
            </div>
            <div class="row row-custom elemento">
              <div class="testata-label col-10">
                {{ $t('dettaglioQuotazione.pagamento') }}
              </div>
              <div class="col-14 textarea no-padding">
                <el-input v-model="testata.pagamento" type="textarea" resize="none" class="custom-input" :maxlength="100" :disabled="disabled" />
              </div>
            </div>
          </div>
          <div class="testata-dx col-xl-12 col-lg-10 col-md-18 col-sm-20 col-22 no-padding">
            <el-radio v-if="testata.tipoVideata === '01'" v-model="testata.ifAccetto" label="Y" class="el-radio-custom col-24" :disabled="disabled || isAccettoDisabled" @change="changeRadio">
              {{ $t('dettaglioQuotazione.accetto') }}
            </el-radio>
            <el-radio v-if="testata.tipoVideata === '01'" v-model="testata.ifAccetto" label="N" class="el-radio-custom col-24" :disabled="disabled || isAlternativaDisabled" @change="changeRadio">
              {{ $t('dettaglioQuotazione.alternativa') }}
            </el-radio>
            <el-radio v-if="testata.tipoVideata === '01'" v-model="testata.ifAccetto" label="D" class="el-radio-custom col-24" :disabled="disabled" @change="changeRadio">
              {{ $t('dettaglioQuotazione.declino') }}
            </el-radio>

            <el-radio v-if="testata.tipoVideata === '02'" v-model="testata.ifAccetto" label="Y" class="el-radio-custom col-24" :disabled="disabled || isAccettoDisabled" @change="changeRadio">
              {{ $t('dettaglioQuotazione.accetto') }}
            </el-radio>
            <el-radio v-if="testata.tipoVideata === '02'" v-model="testata.ifAccetto" label="D" class="el-radio-custom col-24" :disabled="disabled" @change="changeRadio">
              {{ $t('dettaglioQuotazione.declino') }}
            </el-radio>

            <div class="separatore-div col-24">
              <div class="separatore" />
            </div>
            <!--
            <div class="importo col-24">
              <div class="my-label">
                {{ $t('dettaglioQuotazione.importo').toUpperCase() }}
              </div>
              <el-input 
                v-model="testata.importo" 
                :maxlength="15" class="custom-input"
                @focus="focusInterventi" :disabled="disabled"
                v-if="testata.ifInterventi === 'Y'"
              />
              <el-input 
                v-model="testata.importo" 
                :maxlength="15" class="custom-input"
                @blur="onBlur('importo')" @input="onInput('importo')" 
                @focus="onFocus('importo')" :disabled="disabled"
                v-else
              />
              <el-select v-model="testata.codDivisa" class="custom-select-el" placeholder="" :disabled="disabled">
                <el-option
                  v-for="item in divise"
                  :key="item.codDivisa"
                  :label="item.descDivisa"
                  :value="item.codDivisa"
                >
                </el-option>
              </el-select>
            </div>
            <div class="oneri-sicurezza col-24">
              <div class="my-label">
                {{ $t('dettaglioQuotazione.oneriSicurezza') }}
              </div>
              <el-input 
                v-model="testata.oneriSic" 
                :maxlength="15" class="custom-input"
                @blur="onBlur('oneriSic')" @input="onInput('oneriSic')" 
                @focus="onFocus('oneriSic')" :disabled="disabled || checkedOneriNonPrevisti"
              />
              <div class="divisa" />
            </div>
            <div class="oneri-sicurezza col-24">
              <div class="non-previsti">
                <el-checkbox class="custom-checkbox" v-model="checkedOneriNonPrevisti" @change="changeNonPrevisti" :disabled="disabled">
                  {{ $t('dettaglioQuotazione.nonPrevisti') }}
                </el-checkbox>
              </div>
              <div class="divisa" />
            </div>
            <div class="importo col-24" v-if="testata.ifInterventi === 'Y'" style="margin-top: 5px">
              <div class="my-label">
                {{ $t('dettaglioQuotazione.importoAlt').toUpperCase() }}
              </div>
              <el-input 
                v-model="testata.importoAlt" 
                :maxlength="15" class="custom-input"
                @focus="focusInterventi" :disabled="disabled"
                v-if="testata.ifInterventi === 'Y'"
              />
              <el-input 
                v-model="testata.importoAlt" 
                :maxlength="15" class="custom-input"
                @blur="onBlur('importoAlt')" @input="onInput('importoAlt')" 
                @focus="onFocus('importoAlt')" :disabled="disabled"
                v-else
              />
              <el-select v-model="testata.codDivisa" class="custom-select-el" placeholder="" :disabled="disabled">
                <el-option
                  v-for="item in divise"
                  :key="item.codDivisa"
                  :label="item.descDivisa"
                  :value="item.codDivisa"
                >
                </el-option>
              </el-select>
            </div>
            <div class="oneri-sicurezza col-24" v-if="testata.ifInterventi === 'Y'">
              <div class="my-label">
                {{ $t('dettaglioQuotazione.oneriSicurezza') }}
              </div>
              <el-input 
                v-model="testata.oneriSicAlt" 
                :maxlength="15" class="custom-input"
                @blur="onBlur('oneriSicAlt')" @input="onInput('oneriSicAlt')" 
                @focus="onFocus('oneriSicAlt')" :disabled="disabled || checkedOneriNonPrevistiAlt"
              />
              <div class="divisa" />
            </div>
            <div class="oneri-sicurezza col-24" v-if="testata.ifInterventi === 'Y'">
              <div class="non-previsti">
                <el-checkbox class="custom-checkbox" v-model="checkedOneriNonPrevistiAlt" @change="changeNonPrevistiAlt" :disabled="disabled">
                  {{ $t('dettaglioQuotazione.nonPrevisti') }}
                </el-checkbox>
              </div>
              <div class="divisa" />
            </div>
            -->
            <div class="importo col-24">
              <div class="my-label">
                {{ $t('dettaglioQuotazione.importo').toUpperCase() }}
              </div>
              <el-input 
                v-model="importo" 
                :maxlength="15" class="custom-input"
                @focus="focusInterventi" :disabled="disabled"
                v-if="testata.ifInterventi === 'Y'"
              />
              <el-input 
                v-model="importo" 
                :maxlength="15" class="custom-input"
                @blur="onBlurGen('importo')" @input="onInputGen('importo')" 
                @focus="onFocusGen('importo')" :disabled="disabled"
                v-else
              />
              <el-select v-model="testata.codDivisa" class="custom-select-el" placeholder="" :disabled="disabled">
                <el-option
                  v-for="item in divise"
                  :key="item.codDivisa"
                  :label="item.descDivisa"
                  :value="item.codDivisa"
                >
                </el-option>
              </el-select>
            </div>
            <div class="oneri-sicurezza col-24">
              <div class="my-label">
                {{ $t('dettaglioQuotazione.oneriSicurezza') }}
              </div>
              <el-input 
                v-model="oneriSic" 
                :maxlength="15" class="custom-input"
                @blur="onBlurGen('oneriSic')" @input="onInputGen('oneriSic')" 
                @focus="onFocusGen('oneriSic')" :disabled="disabled || checkedOneriNonPrevistiGen"
              />
              <div class="divisa" />
            </div>
            <div class="oneri-sicurezza col-24">
              <div class="non-previsti">
                <el-checkbox class="custom-checkbox" v-model="checkedOneriNonPrevistiGen" @change="changeNonPrevistiGen" :disabled="disabled">
                  {{ $t('dettaglioQuotazione.nonPrevisti') }}
                </el-checkbox>
              </div>
              <div class="divisa" />
            </div>
          </div>
        </div>

        <div class="button-interventi-div">
          <el-button size="small" @click="openInterventi" class="custom-button button-interventi" v-if="testata.ifInterventi === 'Y'">
            {{ $t('dettaglioQuotazione.dettaglioInterventi').toUpperCase() }}
          </el-button>
        </div>

        <el-tabs v-model="tabActive" type="card" class="col-24 no-padding custom-tabs tabs-documenti" @tab-click="changeTabDocumenti" :class="[codLang === 'es_ES' ? 'tabs-spagna' : '']">
          <el-tab-pane key="stabilimento">
            <div style="width: 200px" slot="label">
              <div class="col-24 no-padding">
                {{ $t('dettaglioQuotazione.stabilimento') }}
              </div>
              <div class="col-24 no-padding barra"></div>
            </div>
            <el-table :data="docStabilimento" class="col-24 no-padding custom-table" :row-class-name="getRowClass">
              <el-table-column
                label="#"
                width="30"
              >
                <template slot-scope="scope">
                  <div class="name-wrapper">
                    {{ scope.$index + 1 }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="tipoDoc"
                :label="$t('dettaglioQuotazione.tipoDocumento')"
                min-width="140"
              />
              <el-table-column
                header-align="center" align="center"
                :label="$t('dettaglioQuotazione.caricatoIl')"
                width="140"
              >
                <template slot-scope="scope">
                  <div class="name-wrapper">
                    {{ (scope.row.dataCar) ? moment(scope.row.dataCar, 'DDMMYYYY').format('DD/MM/YYYY') : '' }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="utenteCar"
                :label="$t('dettaglioQuotazione.caricatoDa')"
                min-width="160"
              />
              <el-table-column
                label=""
                width="100"
              >
                <template slot-scope="scope">
                  <div class="icone-div">
                    <icon name="riv-searchPas" scale="1" class="icona pointer" @click.native="previewDocumento(scope.row)" />

                    <el-tooltip class="item" effect="dark"
                      :content="(scope.row.utentePV + ' (' + scope.row.usernamePV + ') ' + ' - ' + 
                                moment(scope.row.dataPV, 'DDMMYYYY').format('DD/MM/YYYY') + ' ' +
                                moment(scope.row.oraPV, 'HHmmss').format('HH:mm'))"
                      placement="left"
                      v-if="(scope.row.statusDoc && scope.row.statusDoc === 'L')"
                    >
                       <icon name="riv-downloadPas" scale="1" class="icona-pv pointer" @click.native="downloadDoc(scope.row)" />
                    </el-tooltip>
                    <icon v-else name="riv-downloadPas" scale="1" class="icona pointer" @click.native="downloadDoc(scope.row)" />
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane key="fornitore">
            <div style="width: 200px" slot="label">
              <div class="col-24 no-padding">
                {{ $t('dettaglioQuotazione.fornitore') }}
              </div>
              <div class="col-24 no-padding barra"></div>
            </div>
            <el-table :data="docFornitore" class="col-24 no-padding custom-table" :row-class-name="getRowClass">
              <el-table-column
                label="#"
                width="30"
              >
                <template slot-scope="scope">
                  <div class="name-wrapper">
                    {{ scope.$index + 1 }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="tipoDoc"
                :label="$t('dettaglioQuotazione.tipoDocumento')"
                min-width="140"
              />
              <el-table-column
                prop="nomeDoc"
                :label="$t('dettaglioQuotazione.nomeDocumento')"
                min-width="130"
              />
              <el-table-column
                header-align="center" align="center"
                :label="$t('dettaglioQuotazione.caricatoIl')"
                width="110"
              >
                <template slot-scope="scope">
                  <div class="name-wrapper">
                    {{ (scope.row.dataCar) ? moment(scope.row.dataCar, 'DDMMYYYY').format('DD/MM/YYYY') : '' }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="utenteCar"
                :label="$t('dettaglioQuotazione.caricatoDa')"
                min-width="100"
              />
              <el-table-column
                header-align="center" align="center"
                :label="$t('dettaglioQuotazione.inviatoIl')"
                width="110"
              >
                <template slot-scope="scope">
                  <div class="name-wrapper">
                    {{ (scope.row.dataInv) ? moment(scope.row.dataInv, 'DDMMYYYY').format('DD/MM/YYYY') : '' }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                label=""
                width="90"
                label-class-name="header-add"
              >
                <template slot-scope="scope" slot="header">
                  <el-tooltip class="item" effect="dark" :content="($t('dettaglioQuotazione.caricaDocumento'))" placement="top" v-if="(!disabled && testata.ifAccetto !== 'D')">
                    <i class="el-icon-circle-plus icona-add pointer" :key="scope.row" @click="goToUpload" />
                  </el-tooltip>
                </template>
                <template slot-scope="scope">
                  <div class="icone-div">
                    <icon name="riv-delete2" scale="1" class="icona pointer" @click.native="deleteDoc(scope.row)" v-if="scope.row.ifElimina === 'Y'" />
                    <icon name="riv-searchPas" scale="1" class="icona pointer" @click.native="previewDocumento(scope.row)" />
                    <icon name="riv-downloadPas" scale="1" class="icona pointer" @click.native="downloadDoc(scope.row)" />
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div class="dx col-xl-8 col-24" v-loading="loadingPreview">
        <div class="col-24 no-padding titolo">
          {{ $t('dettaglioQuotazione.tipoDocumento') }}
        </div>
        <div class="info-upload col-24 no-padding" v-if="ifUpload">
          <el-select v-model="tipoDocSelected" class="custom-select-el" placeholder="" :disabled="disabled">
            <el-option
              v-for="item in tipoDoc"
              :key="item.codTipoDoc"
              :label="item.descTipoDoc"
              :value="item.codTipoDoc">
            </el-option>
          </el-select>
          <el-button class="custom-button" type="primary" @click="uploadDoc()" :disabled="(!fileToUpload || disabled)">
            {{ $t('dettaglioQuotazione.upload').toUpperCase() }}
          </el-button>
        </div>
        <div class="info-download col-24 no-padding" v-else>
          <div class="nome-doc">
            {{ docPreview.tipoDoc ? docPreview.tipoDoc : '-' }}
          </div>
          <el-button class="custom-button" type="primary" @click="downloadDoc(docPreview)" :disabled="(!docPreview.keyDoc)">
            {{ $t('dettaglioQuotazione.download').toUpperCase() }}
          </el-button>
        </div>
        <div class="col-24 no-padding nome-file" v-if="fileToUpload">
          {{ fileToUpload ? fileToUpload.name : ''}}
        </div>
        <div class="row row-custom doc-container" 
          :style="[fileToUpload ? 
            {minHeight: '335px', height: (contenitoreHeight - 260) + 'px', paddingTop: '5px', maxHeight: '640px'} 
            : {minHeight: '335px', height: (contenitoreHeight - 260) + 'px', paddingTop: '15px', maxHeight: '640px'}
          ]"
        >
          <div class="doc" v-if="ifUpload && !fileToUpload">
            <el-upload
              :disabled="disabled"
              class="avatar-uploader"
              accept=".png, .jpg, .jpeg, .pdf, .doc, .docx, .xls, .xlsx"
              action=""
              :show-file-list="false"
              :on-change="changeUploadList"
              :auto-upload="false"
            >
              <div class="add">
                <i class="el-icon-circle-plus add-icon" />
                <div class="el-upload__text">{{ $t('dettaglioQuotazione.nuovoDoc') }}</div>
              </div>
            </el-upload>
          </div>
          <div class="file-preview" v-if="ifUpload && fileToUpload">
            <icon name="riv-delete2" scale="1.5" class="delete pointer" @click.native="deleteDocPreview" />
            <pdf :src="filePreview" :style="{minHeight: '328px', height: (contenitoreHeight - 267) + 'px'}" v-if="filePreview" />
            <img :src="imgPreview" :style="{minHeight: '328px', height: (contenitoreHeight - 267) + 'px'}" v-else>
          </div>
          <div class="preview-img" v-if="(!ifUpload)">
            <img @click="downloadDoc(docPreview)" :src="imageUrl" :style="{minHeight: '318px', height: (contenitoreHeight - 277) + 'px'}" class="pointer">
          </div>
        </div>
      </div>
    </div>
    <div class="bottoni col-xl-16 col-24">
      <el-button size="small" @click="saveQuotazione('S')" class="custom-button" type="primary" :disabled="disabled">
        {{ $t('dettaglioQuotazione.salva').toUpperCase() }}
      </el-button>
      <el-button size="small" @click="saveQuotazione('I')" class="custom-button" type="primary" :disabled="disabled">
        {{ $t('dettaglioQuotazione.invia').toUpperCase() }}
      </el-button>
    </div>

    <el-dialog :title="$t('dettaglioQuotazione.note').toUpperCase()"
               :visible.sync="noteVisible" :append-to-body="true" :close-on-click-modal="false"
               custom-class="custom-dialog offset-xl-7 col-xl-10 offset-lg-7 col-lg-10 offset-md-6 col-md-12 offset-sm-4 col-sm-16 offset-2 col-20 modal-note">

      <div class="error-note col-24 no-padding" v-if="errorNote">
        {{ $t('dettaglioQuotazione.noteDeclinoObblig') }}
      </div>
      <div class="col-24 textarea no-padding">
        <el-input v-model="noteTemp" type="textarea" resize="none" class="custom-input" :maxlength="1000" :disabled="disabled" />
      </div>

      <span slot="footer" class="dialog-footer">
        <div class="bottoni">
          <el-button class="custom-button" @click="closeNote">{{ $t('dettaglioQuotazione.annulla').toUpperCase() }}</el-button>
          <el-button class="custom-button" type="primary" @click="salvaNote" :disabled="disabled">{{ $t('dettaglioQuotazione.salva').toUpperCase() }}</el-button>
        </div>
      </span>

    </el-dialog>

    <el-dialog 
      :title="$t('dettaglioQuotazione.dettaglioInterventi').toUpperCase()"
      :visible.sync="interventiVisible" :append-to-body="true" :close-on-click-modal="false"
      custom-class="custom-dialog col-xl-16 col-23 modal-interventi"
      @close="closeInterventi"
    >

      <div v-loading="interventiLoading" class="interventi-container">
        <div class="row row-custom">
          <div class="col-12 no-padding">
            <span class="interventi-label">
              {{ $t('dettaglioQuotazione.importoProposta').toUpperCase() }}
            </span>
            <span class="interventi-value">
              {{ importoProposta ? (importoProposta + ' €') : ' - ' }}
            </span>
          </div>
          <div class="col-12 no-padding" v-if="testata.tipoVideata === '01'">
            <span class="interventi-label">
              {{ $t('dettaglioQuotazione.propostaAlternativa').toUpperCase() }}
            </span>
            <span class="interventi-value">
              {{ propostaAlternativa ? (propostaAlternativa + ' €') : ' - ' }}
            </span>
          </div>
        </div>

        <el-table :data="interventi" class="col-24 no-padding custom-table">
          <el-table-column
            label="#"
            width="20"
          >
            <template slot-scope="scope">
              <div class="name-wrapper">
                {{ ((currentPage - 1) * pag_for) + scope.$index + 1 }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="codProd"
            :label="$t('dettaglioQuotazione.codice')"
            width="70"
            align="center" header-align="center"
          />
          <el-table-column
            header-align="center" align="center"
            :label="$t('dettaglioQuotazione.qta')"
            width="85"
          >
            <template slot-scope="scope">
              <div class="name-wrapper">
                {{ scope.row.qta + ' ' + scope.row.uMis }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('dettaglioQuotazione.descrizione')"
            min-width="160"
          >
            <template slot-scope="scope">
              <el-tooltip class="item" effect="dark" placement="left" v-if="scope.row.descEstesa">
                <div slot="content" v-html="formattedContent(scope.row.descEstesa)"></div>
                <div class="name-wrapper">
                  {{ scope.row.desc }}
                </div>
              </el-tooltip>
              <div class="name-wrapper" v-else>
                {{ scope.row.desc }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center" align="center"
            :label="$t('dettaglioQuotazione.consegna')"
            width="130"
          >
            <template slot-scope="scope">
              <div class="input-wrapper">
                <el-input 
                  v-model="formInterventi[scope.row.codice].numSettCons" 
                  :maxlength="3" class="custom-input" :disabled="disabled" 
                  @input="changeRow(scope.row.codice)"
                />
              </div>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center" align="center"
            :label="$t('dettaglioQuotazione.prezzo')"
            width="150"
          >
            <template slot-scope="scope">
              <div class="input-wrapper">
                <el-input 
                  v-model="formInterventi[scope.row.codice].prezzo" 
                  :maxlength="13" class="custom-input" :disabled="disabled" 
                  @input="changeRow(scope.row.codice, 'prezzo')"
                  @blur="onBlurForm(scope.row.codice, 'prezzo')"
                  @focus="onFocusForm(scope.row.codice, 'prezzo')"
                />
              </div>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center" align="center"
            :label="$t('dettaglioQuotazione.alternativa')"
            width="150" v-if="testata.tipoVideata === '01'"
          >
            <template slot-scope="scope">
              <div class="input-wrapper">
                <el-input 
                  v-model="formInterventi[scope.row.codice].prezzoAlt" 
                  :maxlength="13" class="custom-input" :disabled="disabled"
                  @input="changeRow(scope.row.codice, 'prezzoAlt')"
                  @blur="onBlurForm(scope.row.codice, 'prezzoAlt')"
                  @focus="onFocusForm(scope.row.codice, 'prezzoAlt')"
                />
              </div>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center" align="center"
            :label="$t('dettaglioQuotazione.nota')"
            width="220" v-if="testata.tipoVideata === '01'"
          >
            <template slot-scope="scope">
              <div class="select-wrapper">
                <el-select 
                  v-model="formInterventi[scope.row.codice].nota" 
                  class="custom-select-el" placeholder="" :disabled="disabled"
                  @change="changeRow(scope.row.codice)" clearable
                >
                  <el-option
                    v-for="item in formNote"
                    :key="item.codNota"
                    :label="item.descNota"
                    :value="item.codNota"
                  >
                  </el-option>
                </el-select>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination 
          v-if="(nrPages > 1)" 
          :current-page="currentPage" 
          class="custom-pagination"
          background
          layout="prev, pager, next"
          :total="nrItems"
          :page-size="pag_for"
          @current-change="changePage"
        />
      </div>

      <span slot="footer" class="dialog-footer">
        <div class="bottoni">
          <el-button class="custom-button" type="primary" @click="saveInterventi(false, false)" :disabled="disabled || interventiLoading">{{ $t('dettaglioQuotazione.salva').toUpperCase() }}</el-button>
          <el-button class="custom-button" type="primary" @click="saveInterventi(true, false)" :disabled="disabled || interventiLoading">{{ $t('dettaglioQuotazione.salvaChiudi').toUpperCase() }}</el-button>
        </div>
      </span>

    </el-dialog>
  </div>
</template>

<script>
  import {bus} from '@/components/Bus.js'
  import moment from 'moment'
  import numeral from 'numeral'
  import pdf from 'vue-pdf'

  export default {
    components: {pdf},
    name: 'DettaglioQuotazione',
    props: {
      contenitoreHeight: {
        type: Number,
        required: true,
        default: 550
      }
    },
    i18n: {
      messages: {
        it_IT: {
          dettaglioQuotazione: {
            quotazione: 'Richiesta di Quotazione N. ',
            del: 'del',
            vsRif: 'Vs. Riferimento',
            validaFino: 'Valida Fino',
            note: 'Note',
            accetto: 'ACCETTO Proposta',
            alternativa: 'Propongo Alternativa',
            declino: 'DECLINO - Non eseguo',
            importo: 'Importo',
            importoAlt: 'Alternativa',
            stabilimento: 'Stabilimento',
            fornitore: 'Fornitore',
            idDocumento: 'ID Documento',
            nomeDocumento: 'Nome Documento',
            tipoDocumento: 'Tipo Documento',
            caricatoIl: 'Caricato Il',
            inviatoIl: 'Inviato Il',
            download: 'Download',
            upload: 'Upload',
            nuovoDoc: 'Selezionare un documento da caricare',
            caricamentoOK: 'Documento salvato correttamente',
            caricamentoKO: 'Errore di caricamento',
            attenzione: 'Attenzione',
            ifCancellare: 'Cancellare definitivamente il documento selezionato?',
            ok: 'Ok',
            annulla: 'Annulla',
            erroreImporto: 'Importo Massimo',
            salva: 'Salva',
            invia: 'Invia',
            confermaSalva: 'Dati e documenti inseriti verranno SALVATI ma non inviati al Back Office. \nConfermi?',
            confermaInvia: 'Dati e documenti inseriti verranno salvati e INVIATI al Back Office. Non saranno più modificabili. \nConfermi?',
            si: 'Sì',
            no: 'No',
            caricaDocumento: 'Carica Documento',
            caricatoDa: 'Caricato Da',
            resa: 'Resa',
            pagamento: 'Pagamento',
            consegna: 'Consegna',
            settimaneDaOrdine: 'Settimane dall\'ordine',
            oneriSicurezza: 'di cui Oneri Sicurezza',
            noteDeclinoObblig: 'Note obbligatorie in caso di declino',
            pagamentoObbligatorio: 'Campo PAGAMENTO obbligatorio',
            nonPrevisti: 'Non previsti',
            confermaInviaIfAccetto: 'Attenzione!!! Nel caso di proposta accettata tutti i documenti che non siano il Verbale di Sopralluogo o i Cataloghi Fornitori non verranno inviati.',
            dettaglioInterventi: 'Dettaglio Interventi',
            codice: 'Codice',
            qta: 'Quantità',
            descrizione: 'Descrizione',
            consegna: 'Consegna (sett)',
            prezzo: 'Prezzo unitario (€)',
            alternativa: 'Alternativa (€)',
            nota: 'Nota',
            salvaChiudi: 'Salva e chiudi',
            importoProposta: 'Importo proposta',
            propostaAlternativa: 'Proposta alternativa',
            resaObbligatoria: 'Campo RESA obbligatorio',
            validitaObbligatoria: 'Campo VALIDA FINO obbligatorio',
            inviataIl: 'Inviata il',
            dataScadenza: 'Data Scadenza',
            tecnico: 'Tecnico',
            impUfficioAcquisti: 'Uff. Acquisti'
          }
        },
        fr_FR: {
          dettaglioQuotazione: {
            quotazione: 'Requête de devis Nr. ',
            del: 'du',
            vsRif: 'Votre référence',
            validaFino: 'Valable jusqu\'à',
            note: 'Note',
            accetto: 'ACCEPTE Proposition',
            alternativa: 'Propose alternative',
            declino: 'REFUSE - n\'effectue pas',
            importo: 'Montant',
            importoAlt: 'Alternative',
            stabilimento: 'Etablissement',
            fornitore: 'Fournisseur',
            idDocumento: 'Identifiant Document',
            nomeDocumento: 'Nom du Document',
            tipoDocumento: 'Tipologie de Document',
            caricatoIl: 'Téléchargé le',
            inviatoIl: 'Envoyé le',
            download: 'Download',
            upload: 'Upload',
            nuovoDoc: 'Selectionner un document à télécharger',
            caricamentoOK: 'Document mis à jour correctement',
            caricamentoKO: 'Erreur de téléchargement',
            attenzione: 'Attention',
            ifCancellare: 'Eliminer définitivemet le document selectionné?',
            ok: 'Ok',
            annulla: 'Annuler',
            erroreImporto: 'Montant Maximum',
            salva: 'Sauvegarder',
            invia: 'Envoyer',
            confermaSalva: 'Les données et les documents saisis seront mis à jour mais ne seront pas envoyés au service achats. \nVous confirmez?',
            confermaInvia: 'Les données et les documents saisis seront mis à jour et seront envoyés au service achats. Ils ne seront plus modifiables. \nVous confirmez?',
            si: 'Oui',
            no: 'Non',
            caricaDocumento: 'Téléchargez Document',
            caricatoDa: 'Téléchargé par',
            resa: 'Retour',
            pagamento: 'Paiement',
            consegna: 'Livraison',
            settimaneDaOrdine: 'Semaines à partir de Commande',
            oneriSicurezza: 'Y compris les charges pour la Sécurité',
            noteDeclinoObblig: 'Notes obligatoires en cas de rejet',
            pagamentoObbligatorio: 'Champ PAIEMENT obligatoire',
            nonPrevisti: 'Pas prévus',
            confermaInviaIfAccetto: 'Attention!!! Dans le cas de proposition acceptée tous les documents, exclus le rapport d\'inspection et les catalogues, ne seront pas envoyés.',
            dettaglioInterventi: 'Dettaglio Interventi',
            codice: 'Codice',
            qta: 'Quantità',
            descrizione: 'Descrizione',
            consegna: 'Consegna (sett)',
            prezzo: 'Prezzo unitario (€)',
            alternativa: 'Alternativa (€)',
            nota: 'Nota',
            salvaChiudi: 'Salva e chiudi',
            importoProposta: 'Importo proposta',
            propostaAlternativa: 'Proposta alternativa',
            resaObbligatoria: 'Campo RESA obbligatorio',
            validitaObbligatoria: 'Campo VALIDA FINO obbligatorio',
            inviataIl: 'Envoyé le',
            dataScadenza: 'Date Expiration',
            tecnico: 'Technicien',
            impUfficioAcquisti: 'Bureau Achats'
          }
        },
        es_ES: {
          dettaglioQuotazione: {
            quotazione: 'Petición de oferta Nº. ',
            del: 'del',
            vsRif: 'Vs. Referencia',
            validaFino: 'Valida hasta',
            note: 'Notas',
            accetto: 'ACEPTA Propuesta',
            alternativa: 'Propongo Alternativa',
            declino: 'DECLINO - No ejecuto',
            importo: 'Importe',
            importoAlt: 'Alternativa',
            stabilimento: 'Documentos subidos por SISE',
            fornitore: 'Documentos subidos por proveedor',
            idDocumento: 'Documento Identificativo',
            nomeDocumento: 'Nombre Documento',
            tipoDocumento: 'Tipologia de Documento',
            caricatoIl: 'Subido el',
            inviatoIl: 'Enviado el',
            download: 'Descargar',
            upload: 'Subir',
            nuovoDoc: 'Seleccionar un documento para cargar',
            caricamentoOK: 'Documento guardado correctamente',
            caricamentoKO: 'Error de carga',
            attenzione: 'Atención',
            ifCancellare: 'Borrar definitivamente el documento seleccionado?',
            ok: 'Ok',
            annulla: 'Anular',
            erroreImporto: 'Importe Maximo',
            salva: 'Guardar',
            invia: 'Enviar',
            confermaSalva: 'Datos y documentos serán GUARDADOS pero no enviados al Back office. \nConfirmar?',
            confermaInvia: 'Datos y documentos serán guardados y ENVIADOS al Back office. \nConfirmar?',
            si: 'Si',
            no: 'No',
            caricaDocumento: 'Subir Documento',
            caricatoDa: 'Subido por',
            resa: 'Portes',
            pagamento: 'Forma de Pago',
            consegna: 'Entrega',
            settimaneDaOrdine: 'Semanas a partir del pedido',
            oneriSicurezza: 'de las cuales Cargas de Seguridad',
            noteDeclinoObblig: 'Notas obligatorias en caso de declinar',
            pagamentoObbligatorio: 'Campo PAGO obligatorio',
            nonPrevisti: 'No previstos',
            confermaInviaIfAccetto: '¡¡¡Atención!!! En caso de propuesta aceptada, no se enviarán todos los documentos que no sean el informe de inspección o los catálogos de proveedores.',
            dettaglioInterventi: 'Detalle intervenciónes',
            codice: 'Codigo',
            qta: 'Cantidad',
            descrizione: 'Descripción',
            consegna: 'Entrega (sem)',
            prezzo: 'Precio (€)',
            alternativa: 'Alternativa (€)',
            nota: 'Nota',
            salvaChiudi: 'Guardar y cerrar',
            importoProposta: 'Importe Propuesta',
            propostaAlternativa: 'Propuesta Alternativa',
            resaObbligatoria: 'Campo PORTES obligatorio',
            validitaObbligatoria: 'Campo VALIDA HASTA obligatorio',
            inviataIl: 'Enviado el',
            dataScadenza: 'Fecha Vencimiento',
            tecnico: 'Técnico',
            impUfficioAcquisti: 'Oficina Compras'
          }
        },
        de_DE: {
          dettaglioQuotazione: {
            quotazione: 'Angebotsanforderung Nr. ',
            del: 'von',
            vsRif: 'Ihre Referenz',
            validaFino: 'Gültig bis',
            note: 'Anmerkungen',
            accetto: 'AKZEPTIEREN Vorschlag',
            alternativa: 'Alternativer Vorschlag',
            declino: 'ABGELEHNT - führt nicht durch',
            importo: 'Betrag',
            importoAlt: 'Alternative',
            stabilimento: 'Niederlassung/Werk',
            fornitore: 'Lieferant',
            idDocumento: 'Dokument-ID',
            nomeDocumento: 'Name des Dokuments',
            tipoDocumento: 'Dokument-Typ',
            caricatoIl: 'Hochgeladen am',
            inviatoIl: 'Gesendet am',
            download: 'Herunterladen',
            upload: 'Hochladen',
            nuovoDoc: 'Wählen Sie ein Dokument zum Hochladen',
            caricamentoOK: 'Dokument erfolgreich gespeichert',
            caricamentoKO: 'Fehler beim Hochladen',
            attenzione: 'Achtung',
            ifCancellare: 'Ausgewähltes Dokument endgültig löschen?',
            ok: 'Ok',
            annulla: 'Abbrechen',
            erroreImporto: 'Maximaler Betrag',
            salva: 'Speichern',
            invia: 'Senden',
            confermaSalva: 'Die eingegebenen Daten und Dokumente werden GESPEICHERT, aber nicht an das Back Office gesendet. \nBestätigen?',
            confermaInvia: 'Die eingegebenen Daten und Dokumente werden GESPEICHERT und an das Back-Office gesendet. Sie sind dann nicht mehr bearbeitbar. \nBestätigen?',
            si: 'Ja',
            no: 'Nein',
            caricaDocumento: 'Dokument hochladen',
            caricatoDa: 'Hochgeladen von',
            resa: 'Rücksendung',
            pagamento: 'Zahlung',
            consegna: 'Lieferung',
            settimaneDaOrdine: 'Wochen nach Bestellung',
            oneriSicurezza: 'davon Sicherheitszuschläge',
            noteDeclinoObblig: 'Obligatorische Hinweise im Falle einer Ablehnung',
            pagamentoObbligatorio: 'Pflichtfeld ZAHLUNG',
            nonPrevisti: 'Nicht vorgesehen',
            confermaInviaIfAccetto: 'Achtung!!! Im Falle eines angenommenen Angebots werden alle anderen Dokumente als der Vor-Ort-Bericht oder die Lieferantenkataloge nicht versandt.',
            dettaglioInterventi: 'Leistungsbeschreibung',
            codice: 'Code',
            qta: 'Menge',
            descrizione: 'Beschreibung',
            consegna: 'Lieferung (Kalenderwoche)',
            prezzo: 'Preis (€)',
            alternativa: 'Alternative (€)',
            nota: 'Hinweis/Vermerk/Notiz',
            salvaChiudi: 'Speichern und schließen',
            importoProposta: 'Betrag des Vorschlags',
            propostaAlternativa: 'Alternativer Vorschlag',
            resaObbligatoria: 'Pflichtfeld INCOTERMS',
            validitaObbligatoria: 'Pflichtfeld GÜLTIG BIS',
            inviataIl: 'Gesendet am',
            dataScadenza: 'Ablaufdatum',
            tecnico: 'Techniker',
            impUfficioAcquisti: 'Einkaufsbüro'
          }
        },
        en_GB: {
          dettaglioQuotazione: {
            quotazione: 'Richiesta di Quotazione N. ',
            del: 'del',
            vsRif: 'Vs. Riferimento',
            validaFino: 'Valida Fino',
            note: 'Note',
            accetto: 'ACCETTO Proposta',
            alternativa: 'Propongo Alternativa',
            declino: 'DECLINO - Non eseguo',
            importo: 'Importo',
            importoAlt: 'Alternativa',
            stabilimento: 'Stabilimento',
            fornitore: 'Fornitore',
            idDocumento: 'ID Documento',
            nomeDocumento: 'Nome Documento',
            tipoDocumento: 'Tipo Documento',
            caricatoIl: 'Caricato Il',
            inviatoIl: 'Inviato Il',
            download: 'Download',
            upload: 'Upload',
            nuovoDoc: 'Selezionare un documento da caricare',
            caricamentoOK: 'Documento salvato correttamente',
            caricamentoKO: 'Errore di caricamento',
            attenzione: 'Attenzione',
            ifCancellare: 'Cancellare definitivamente il documento selezionato?',
            ok: 'Ok',
            annulla: 'Annulla',
            erroreImporto: 'Importo Massimo',
            salva: 'Salva',
            invia: 'Invia',
            confermaSalva: 'Dati e documenti inseriti verranno SALVATI ma non inviati al Back Office. \nConfermi?',
            confermaInvia: 'Dati e documenti inseriti verranno salvati e INVIATI al Back Office. Non saranno più modificabili. \nConfermi?',
            si: 'Sì',
            no: 'No',
            caricaDocumento: 'Carica Documento',
            caricatoDa: 'Caricato Da',
            resa: 'Resa',
            pagamento: 'Pagamento',
            consegna: 'Consegna',
            settimaneDaOrdine: 'Settimane dall\'ordine',
            oneriSicurezza: 'di cui Oneri Sicurezza',
            noteDeclinoObblig: 'Note obbligatorie in caso di declino',
            pagamentoObbligatorio: 'Campo PAGAMENTO obbligatorio',
            nonPrevisti: 'Non previsti',
            confermaInviaIfAccetto: 'Attenzione!!! Nel caso di proposta accettata tutti i documenti che non siano il Verbale di Sopralluogo o i Cataloghi Fornitori non verranno inviati.',
            dettaglioInterventi: 'Dettaglio Interventi',
            codice: 'Codice',
            qta: 'Quantità',
            descrizione: 'Descrizione',
            consegna: 'Consegna (sett)',
            prezzo: 'Prezzo unitario (€)',
            alternativa: 'Alternativa (€)',
            nota: 'Nota',
            salvaChiudi: 'Salva e chiudi',
            importoProposta: 'Importo proposta',
            propostaAlternativa: 'Proposta alternativa',
            resaObbligatoria: 'Campo RESA obbligatorio',
            validitaObbligatoria: 'Campo VALIDA FINO obbligatorio',
            inviataIl: 'Sent on',
            dataScadenza: 'Expiration Date',
            tecnico: 'Technician',
            impUfficioAcquisti: 'Purchasing Office'
          }
        },
      }
    },
    computed: {
      isAccettoDisabled: function () {
        if (this.testata.ifInterventi !== 'Y') {
          return false
        }

        // let flag_1 = false
        let flag_2 = false

        /*
        for (let key in this.formInterventi) {
          if (this.formInterventi[key].nota || this.formInterventi[key].prezzoAlt) {
            flag_1 = true
          }
        }
        */

        if (this.testata.importoAlt && parseFloat(this.testata.importoAlt) > 0) {
          flag_2 = true
        }

        // return flag_1 || flag_2
        return flag_2
      },
      isAlternativaDisabled: function () {
        if (this.testata.ifInterventi !== 'Y') {
          return false
        }

        let flag_1 = false

        if (this.testata.importo && parseFloat(this.testata.importo) > 0) {
          flag_1 = true
        }

        return flag_1
      }
    },
    data () {
      return {
        codLang: sessionStorage.getItem('codLang'),
        moment: moment,
        loading: true,
        loadingPreview: false,
        form: {},
        quotazione: {},
        divise: [],
        testata: {},
        docStabilimento: [],
        docFornitore: [],
        tabActive: '0',
        imageUrl: 'static/img/anteprima_' + sessionStorage.getItem('codLang') + '.png',
        ifUpload: false,
        docPreview: {},
        tipoDoc: [],
        tipoDocSelected: '',
        filePreview: null,
        fileToUpload: null,
        imgPreview: 'static/img/anteprima_' + sessionStorage.getItem('codLang') + '.png',
        disabled: false,
        keyDocSelected: '',
        noteVisible: false,
        noteTemp: '',
        errorNote: false,
        checkedOneriNonPrevisti: false,
        checkedOneriNonPrevistiAlt: false,
        interventiVisible: false,
        interventi: [],
        interventiLoading: false,
        formInterventi: {},
        formNote: [],
        pag_for: 10,
        currentPage: 1,
        nrPages: 0,
        nrItems: 0,
        importoProposta: '',
        propostaAlternativa: '',
        importo: '',
        oneriSic: '',
        checkedOneriNonPrevistiGen: false
      }
    },
    mounted: function () {
      bus.$on('changeLanguage', () => {
        this.$set(this, 'codLang', sessionStorage.getItem('codLang'))
      })
    },
    activated: function () {
      this.init()
    },
    deactivated: function () {
      this.resetDati()
    },
    methods: {
      resetDati: function () {
        this.$set(this, 'form', {})
        this.$set(this, 'loading', true)
        this.$set(this, 'loadingPreview', false)
        this.$set(this, 'quotazione', {})
        this.$set(this, 'divise', [])
        this.$set(this, 'testata', {})
        this.$set(this, 'docStabilimento', [])
        this.$set(this, 'docFornitore', [])
        this.$set(this, 'tabActive', '0')
        this.$set(this, 'imageUrl', 'static/img/anteprima_' + sessionStorage.getItem('codLang') + '.png')
        this.$set(this, 'ifUpload', false)
        this.$set(this, 'docPreview', {})
        this.$set(this, 'tipoDoc', [])
        this.$set(this, 'tipoDocSelected', '')
        this.$set(this, 'filePreview', null)
        this.$set(this, 'fileToUpload', null)
        this.$set(this, 'imgPreview', 'static/img/anteprima_' + sessionStorage.getItem('codLang') + '.png')
        this.$set(this, 'disabled', false)
        this.$set(this, 'keyDocSelected', '')
        this.$set(this, 'noteVisible', false)
        this.$set(this, 'noteTemp', '')
        this.$set(this, 'formNote', [])
        this.$set(this, 'formInterventi', {})
        this.$set(this, 'importoProposta', '')
        this.$set(this, 'propostaAlternativa', '')
        this.$set(this, 'importo', '')
        this.$set(this, 'oneriSic', '')
        this.$set(this, 'currentPage', 1)
        this.$set(this, 'nrPages', 0)
        this.$set(this, 'nrItems', 0)
      },
      init: function () {
        this.$store.dispatch('ifObject', 'RDQ_Quotazione')
          .then((ifQuotazione) => {
            if (ifQuotazione) {
              let form = this.$store.state.RDQ_Ricerca
              let quotazione = this.$store.state.RDQ_Quotazione
              this.$set(this, 'form', form)
              this.$set(this, 'quotazione', quotazione)
              this.$set(this, 'disabled', (quotazione.codAvanz === '020' || quotazione.codAvanz === '025' || quotazione.codAvanz === '021'))

              this.getDivise()
              this.loadQuotazione(false)
            } else {
              this.$router.push({name: 'RdQQuotazioni'})
            }
          })
      },
      focusInterventi: function () {
        if (this.testata.ifInterventi === 'Y') {
          this.openInterventi()
        }
      },
      onFocus: function (campo) {
        let val = this.testata[campo].replace(/\./g, '')
        this.$set(this.testata, campo, val)
      },
      onInput: function (campo) {
        let val = this.testata[campo].replace(/\./g, ',').replace(/\s/g, '').replace(/[^0-9,]/g, '')
        if (val) {
          if (val.indexOf(',') === 0) {
            val = '0' + val
          }
          if (val.length > 1 && val.startsWith('0') && !val.startsWith('0,')) {
            val = val.substring(1)
          }
          if (val.indexOf(',') !== val.lastIndexOf(',')) {
            let intero = val.substring(0, val.indexOf(','))
            let decimale = val.substring(parseInt(val.indexOf(',')) + 1).replace(/,/g, '')
            val = intero + ',' + decimale
          }
        }
        this.$set(this.testata, campo, val)
      },
      onBlur: function (campo) {
        let val = this.testata[campo]
        if (!val) {
          val = '0,00'
        }
        if (parseFloat(val.replace(/,/g, '.')) > 999999999999.99) {
          this.$message({
            showClose: true,
            message: this.$t('dettaglioQuotazione.erroreImporto') + ' = 999999999999,99',
            type: 'error',
            duration: process.env.duration
          })
          this.$set(this.testata, campo, '0,00')
        } else {
          val = numeral(val.replace(/,/g, '.')).format('0,0.00')
          val = val.replace(/\./g, '&').replace(/,/g, '.').replace('&', ',')
          this.$set(this.testata, campo, val)
        }
      },
      onFocusGen: function (campo) {
        let val = this[campo].replace(/\./g, '')
        this.$set(this, campo, val)
      },
      onInputGen: function (campo) {
        let val = this[campo].replace(/\./g, ',').replace(/\s/g, '').replace(/[^0-9,]/g, '')
        if (val) {
          if (val.indexOf(',') === 0) {
            val = '0' + val
          }
          if (val.length > 1 && val.startsWith('0') && !val.startsWith('0,')) {
            val = val.substring(1)
          }
          if (val.indexOf(',') !== val.lastIndexOf(',')) {
            let intero = val.substring(0, val.indexOf(','))
            let decimale = val.substring(parseInt(val.indexOf(',')) + 1).replace(/,/g, '')
            val = intero + ',' + decimale
          }
        }
        this.$set(this, campo, val)
      },
      onBlurGen: function (campo) {
        let val = this[campo]
        if (!val) {
          val = '0,00'
        }
        if (parseFloat(val.replace(/,/g, '.')) > 999999999999.99) {
          this.$message({
            showClose: true,
            message: this.$t('dettaglioQuotazione.erroreImporto') + ' = 999999999999,99',
            type: 'error',
            duration: process.env.duration
          })
          this.$set(this, campo, '0,00')
        } else {
          val = numeral(val.replace(/,/g, '.')).format('0,0.00')
          val = val.replace(/\./g, '&').replace(/,/g, '.').replace('&', ',')
          this.$set(this, campo, val)
        }
      },
      goBack: function () {
        this.$router.push({name: 'RdQQuotazioni'})
      },
      getRowClass: function ({row, rowIndex}) {
        if (row.keyDoc === this.keyDocSelected) {
          return 'evidenziato'
        }
      },
      goToUpload: function () {
        this.deleteDocPreview()
        this.$set(this, 'ifUpload', true)
      },
      changeTabDocumenti: function () {
        this.deleteDocPreview()
        this.$set(this, 'ifUpload', false)
      },
      goToNote: function (ifErrorNote) {
        this.$set(this, 'errorNote', ifErrorNote)
        this.$set(this, 'noteTemp', this.testata.note)
        this.$set(this, 'noteVisible', true)
      },
      salvaNote: function () {
        this.$set(this.testata, 'note', this.noteTemp)
        this.$set(this, 'noteVisible', false)
      },
      closeNote: function () {
        this.$set(this, 'noteVisible', false)
      },
      getDivise: function () {
        this.$http.get('richiestediquotazione/divise', {
          params: {
            codLang: this.codLang,
            country: this.form.country
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              this.$set(this, 'divise', response.body.data)
            } else {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
            }
          })
      },
      getTipoDoc: function () {
        this.$http.get('richiestediquotazione/tipodoc', {
          params: {
            codLang: this.codLang,
            country: this.form.country,
            ifAccetto: this.testata.ifAccetto
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              this.$set(this, 'tipoDoc', response.body.data)
              if (response.body.data.length > 0) {
                this.$set(this, 'tipoDocSelected', response.body.data[0].codTipoDoc)
              } else {
                this.$set(this, 'tipoDocSelected', '')
              }
            } else {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
            }
            this.$set(this, 'loading', false)
          })
      },
      loadQuotazione: function (ifUpload, ifCloseInterventi) {
        this.$http.get('richiestediquotazione/quotazione', {
          params: {
            codLang: this.codLang,
            codForn: this.form.codForn,
            country: this.form.country,
            codSoc: this.quotazione.codSoc,
            codStab: this.quotazione.codStab,
            annoCar: moment(this.quotazione.data, 'DDMMYYYY').format('YYYY'),
            numRif: this.quotazione.numRif
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              this.$set(this, 'docStabilimento', response.body.data.stabilimento)
              this.$set(this, 'docFornitore', response.body.data.fornitore)

              if (!ifUpload) {
                let attrib = response.body.attrib
                if (ifCloseInterventi) {
                  this.$set(this.testata, 'importo', attrib.importo)
                  this.$set(this.testata, 'importoAlt', attrib.importoAlt)
                  this.$set(this.testata, 'ifAccetto', attrib.ifAccetto)
                } else {
                  attrib.resa = attrib.resa.replace(/\\n/g, '\n')
                  attrib.pagamento = attrib.pagamento.replace(/\\n/g, '\n')
                  this.$set(this, 'testata', attrib)
                  if (attrib.ifInterventi === 'Y' && this.formNote.length === 0) {
                    this.getNote()
                  }
                }
  
                /*
                // Importo
                let val = this.testata.importo
                val = numeral(val.replace(/,/g, '.')).format('0,0.00')
                val = val.replace(/\./g, '&').replace(/,/g, '.').replace('&', ',')
                this.$set(this.testata, 'importo', val)
                // Importo alternativo
                let val_1 = this.testata.importoAlt
                val_1 = numeral(val_1.replace(/,/g, '.')).format('0,0.00')
                val_1 = val_1.replace(/\./g, '&').replace(/,/g, '.').replace('&', ',')
                this.$set(this.testata, 'importoAlt', val_1)
                // Oneri Sicurezza
                let val_2 = this.testata.oneriSic
                val_2 = numeral(val_2.replace(/,/g, '.')).format('0,0.00')
                val_2 = val_2.replace(/\./g, '&').replace(/,/g, '.').replace('&', ',')
                this.$set(this.testata, 'oneriSic', val_2)
                this.$set(this, 'checkedOneriNonPrevisti', (this.testata.seNonPrevistiOneri === 'Y'))
                let val_3 = this.testata.oneriSicAlt
                val_3 = numeral(val_3.replace(/,/g, '.')).format('0,0.00')
                val_3 = val_3.replace(/\./g, '&').replace(/,/g, '.').replace('&', ',')
                this.$set(this.testata, 'oneriSicAlt', val_3)
                this.$set(this, 'checkedOneriNonPrevistiAlt', (this.testata.seNonPrevistiOneriAlt === 'Y'))
                */

                // Nuovi campi generici per importo e oneri sicurezza
                let importo = attrib.importo
                let importoAlt = attrib.importoAlt
                if (parseFloat(importo.replace(/,/g, '.')) > 0) {
                  importo = numeral(importo.replace(/,/g, '.')).format('0,0.00')
                  importo = importo.replace(/\./g, '&').replace(/,/g, '.').replace('&', ',')
                  this.$set(this, 'importo', importo)

                  let oneriSic = attrib.oneriSic
                  oneriSic = numeral(oneriSic.replace(/,/g, '.')).format('0,0.00')
                  oneriSic = oneriSic.replace(/\./g, '&').replace(/,/g, '.').replace('&', ',')
                  this.$set(this, 'oneriSic', oneriSic)
                  this.$set(this, 'checkedOneriNonPrevistiGen', (attrib.seNonPrevistiOneri === 'Y'))
                } else if (parseFloat(importoAlt.replace(/,/g, '.')) > 0) {
                  importoAlt = numeral(importoAlt.replace(/,/g, '.')).format('0,0.00')
                  importoAlt = importoAlt.replace(/\./g, '&').replace(/,/g, '.').replace('&', ',')
                  this.$set(this, 'importo', importoAlt)

                  let oneriSicAlt = attrib.oneriSicAlt
                  oneriSicAlt = numeral(oneriSicAlt.replace(/,/g, '.')).format('0,0.00')
                  oneriSicAlt = oneriSicAlt.replace(/\./g, '&').replace(/,/g, '.').replace('&', ',')
                  this.$set(this, 'oneriSic', oneriSicAlt)
                  this.$set(this, 'checkedOneriNonPrevistiGen', (attrib.seNonPrevistiOneriAlt === 'Y'))
                } else {
                  this.$set(this, 'importo', '')
                  this.$set(this, 'oneriSic', '')
                  this.$set(this, 'checkedOneriNonPrevistiGen', false)
                }

                // Richiamo il servizio dopo aver settato la testata (il valore ifAccetto)
                this.getTipoDoc()
              } else {
                this.$set(this, 'loading', false)
              }
            } else {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
              this.$set(this, 'loading', false)
            }
          })
      },
      previewDocumento: function (doc) {
        this.deleteDocPreview()
        this.$set(this, 'loadingPreview', true)
        this.$set(this, 'ifUpload', false)
        this.$set(this, 'docPreview', doc)
        this.$http.get('richiestediquotazione/preview', {
          params: {
            container: doc.idCli + doc.idApp,
            dKey: doc.keyDoc
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              this.$set(this, 'imageUrl', 'data:image/jpeg;base64,' + response.body.data.file)
            } else {
              this.$set(this, 'imageUrl', 'static/img/anteprima_' + this.codLang + '.png')
              // this.$set(this, 'docPreview', {})
            }
            this.$set(this, 'loadingPreview', false)
            this.$set(this, 'keyDocSelected', doc.keyDoc)
          })
      },
      downloadDoc: function (doc) {
        this.setStatusDoc(doc)
        if (doc.keyDoc) {
          this.$http.get('portale/tokendoc')
            .then(response => {
              if (response.body.wsToken) {
                let url = (process.env.baseUrlSpringAcquisti + 'print/quotazione/doc?idCli=' + doc.idCli + '&idApp='
                          + doc.idApp + '&keyDoc=' + doc.keyDoc
                          +'&token=' + response.body.wsToken)
                let win = window.open(url, '_blank')
                win.focus()
              } else {
                this.$message({
                  showClose: true,
                  message: response.body.msg[0].msgTxt,
                  type: 'error',
                  duration: process.env.duration
                })
              }
            })
        }
      },
      changeUploadList: function (file, fileList) {
        if (file.raw.type === 'application/pdf') {
          let reader = new FileReader()
          reader.onloadend = () => {
            let base64String = reader.result
              .replace('data:', '')
              .replace(/^.+,/, '')

            this.$set(this, 'filePreview', 'data:application/pdf;base64, ' + base64String)
          }
          reader.readAsDataURL(file.raw)
        } else if (file.raw.type.indexOf('image') >= 0) {
          let array = file.name.split('.')
          let ext = array[array.length - 1]
          let reader = new FileReader()
          reader.onloadend = () => {
            let base64String = reader.result
              .replace('data:', '')
              .replace(/^.+,/, '')

            this.$set(this, 'imgPreview', 'data:image/' + ext + ';base64, ' + base64String)
          }
          reader.readAsDataURL(file.raw)
        } else {
          this.$set(this, 'imgPreview', 'static/img/anteprima_' + this.codLang + '.png')
        }
        this.$set(this, 'fileToUpload', file)
      },
      deleteDocPreview: function () {
        this.$set(this, 'keyDocSelected', '')
        this.$set(this, 'fileToUpload', null)
        this.$set(this, 'filePreview', null)
        this.$set(this, 'imgPreview', 'static/img/anteprima_' + this.codLang + '.png')
        this.$set(this, 'imageUrl', 'static/img/anteprima_' + this.codLang + '.png')
        this.$set(this, 'docPreview', {})
      },
      uploadDoc: function () {
        this.$set(this, 'loading', true)

        let formData = new FormData()
        formData.append('numRif', this.quotazione.numRif)
        formData.append('codTipoDoc', this.tipoDocSelected)
        formData.append('codSoc', this.quotazione.codSoc)
        formData.append('codStab', this.quotazione.codStab)
        formData.append('annoCar', moment(this.quotazione.data, 'DDMMYYYY').format('YYYY'))
        formData.append('tipoRich', this.testata.tipoRich)
        formData.append('file', this.fileToUpload.raw)

        this.$http.post('richiestediquotazione/doc', formData, {
          params: {
            codLang: this.codLang,
            codForn: this.form.codForn,
            country: this.form.country
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              this.$message({
                showClose: true,
                message: this.$t('dettaglioQuotazione.caricamentoOK'),
                type: 'success',
                duration: process.env.duration
              })
              this.deleteDocPreview()
              this.loadQuotazione(true)
            } else {
              this.$message({
                showClose: true,
                message: this.$t('dettaglioQuotazione.caricamentoKO'),
                type: 'error',
                duration: process.env.duration
              })
              this.$set(this, 'loading', false)
            }
          })
      },
      deleteDoc: function (documento) {
        this.$confirm(this.$t('dettaglioQuotazione.ifCancellare'), this.$t('dettaglioQuotazione.attenzione').toUpperCase(), {
          confirmButtonText: this.$t('dettaglioQuotazione.ok').toUpperCase(),
          cancelButtonText: this.$t('dettaglioQuotazione.annulla').toUpperCase(),
          type: 'warning',
          customClass: 'custom-confirm',
          showClose: false,
          closeOnClickModal: false
        }).then(() => {
          this.$set(this, 'loading', true)
          let obj = {
            codSoc: this.quotazione.codSoc,
            codStab: this.quotazione.codStab,
            annoCar: moment(this.quotazione.data, 'DDMMYYYY').format('YYYY'),
            numRif: this.quotazione.numRif,
            keyDoc: documento.keyDoc,
            dataDoc: documento.dataCar,
            tipoRich: this.testata.tipoRich,
            progressivo: documento.progressivo
          }
          this.$http.post('richiestediquotazione/deletedoc', obj, {
            params: {
              codLang: this.codLang,
              country: this.form.country,
              codForn: this.form.codForn
            }
          })
            .then(response => {
              if (response.body.rc === 0) {
                this.$message({
                  showClose: true,
                  message: response.body.msg[0].msgTxt,
                  type: 'success',
                  duration: process.env.duration
                })
                this.deleteDocPreview()
                this.loadQuotazione(true)
              } else {
                this.$message({
                  showClose: true,
                  message: response.body.msg[0].msgTxt,
                  type: 'error',
                  duration: process.env.duration
                })
                this.$set(this, 'loading', false)
              }
            })
        }).catch(() => {
          //
        })
      },
      saveQuotazione: function (tipoSave) {
        if (tipoSave === 'I' && !this.testata.pagamento && this.testata.ifAccetto !== 'D') {
          this.$message({
            showClose: true,
            message: this.$t('dettaglioQuotazione.pagamentoObbligatorio'),
            type: 'error',
            duration: process.env.duration
          })
          // Mostro messaggio di errore (campo PAGAMENTO obbligatorio) e fermo il processo di salvataggio
          return
        }
        if (tipoSave === 'I' && !this.testata.resa && this.testata.ifAccetto !== 'D') {
          this.$message({
            showClose: true,
            message: this.$t('dettaglioQuotazione.resaObbligatoria'),
            type: 'error',
            duration: process.env.duration
          })
          // Mostro messaggio di errore (campo RESA obbligatorio) e fermo il processo di salvataggio
          return
        }
        if (tipoSave === 'I' && !this.testata.dataVal && this.testata.ifAccetto !== 'D') {
          this.$message({
            showClose: true,
            message: this.$t('dettaglioQuotazione.validitaObbligatoria'),
            type: 'error',
            duration: process.env.duration
          })
          // Mostro messaggio di errore (campo VALIDA FINO obbligatorio) e fermo il processo di salvataggio
          return
        }
        let message = ''
        if (this.testata.ifAccetto === 'Y') {
          message = '<span>' + this.$t('dettaglioQuotazione.confermaInviaIfAccetto') + '<br><br>' + this.$t('dettaglioQuotazione.confermaInvia') + '</span>'
        } else {
          message = '<span>' + this.$t('dettaglioQuotazione.confermaInvia') + '</span>'
        }
        this.$confirm(
          (tipoSave === 'S') ?
            this.$t('dettaglioQuotazione.confermaSalva')
            :
            message,
          this.$t('dettaglioQuotazione.attenzione').toUpperCase(),
          {
            confirmButtonText: this.$t('dettaglioQuotazione.si').toUpperCase(),
            cancelButtonText: this.$t('dettaglioQuotazione.no').toUpperCase(),
            type: 'warning',
            customClass: 'custom-confirm salva-quotazioni',
            showClose: false,
            closeOnClickModal: false,
            iconClass: '',
            dangerouslyUseHTMLString: true
          }
        ).then(() => {
          if (this.testata.ifAccetto !== 'D' || tipoSave === 'S' || this.testata.note) {
            this.$set(this, 'loading', true)
            let data = {
              rifForn: this.testata.rifForn,
              dataRif: this.testata.dataRif,
              dataVal: (this.testata.ifAccetto === 'D') ? '' : this.testata.dataVal,
              note: this.testata.note,
              ifAccetto: this.testata.ifAccetto,
              importo: (this.testata.ifAccetto === 'D') ? '' : (this.testata.ifAccetto === 'Y' ? this.importo : ''),
              importoAlt: (this.testata.ifAccetto === 'D') ? '' : (this.testata.ifAccetto === 'N' ? this.importo : ''),
              tipoSave: tipoSave,
              codDivisa: (this.testata.ifAccetto === 'D') ? '' : this.testata.codDivisa,
              numRif: this.quotazione.numRif,
              codSoc: this.quotazione.codSoc,
              codStab: this.quotazione.codStab,
              annoCar: moment(this.quotazione.data, 'DDMMYYYY').format('YYYY'),
              tipoRich: this.testata.tipoRich,
              resa: (this.testata.ifAccetto === 'D') ? '' : this.testata.resa,
              pagamento: (this.testata.ifAccetto === 'D') ? '' : this.testata.pagamento,
              numSettCons: (this.testata.ifAccetto === 'D') ? '' : this.testata.numSettCons,
              oneriSic: (this.testata.ifAccetto === 'D') ? '' : (this.testata.ifAccetto === 'Y' ? this.oneriSic : ''),
              seNonPrevistiOneri: (this.testata.ifAccetto === 'D') ? '' : (this.testata.ifAccetto === 'Y' ? (this.checkedOneriNonPrevistiGen ? 'Y' : 'N') : ''),
              oneriSicAlt: (this.testata.ifAccetto === 'D') ? '' : (this.testata.ifAccetto === 'N' ? this.oneriSic : ''),
              seNonPrevistiOneriAlt: (this.testata.ifAccetto === 'D') ? '' : (this.testata.ifAccetto === 'N' ? (this.checkedOneriNonPrevistiGen ? 'Y' : 'N') : '')
            }
            this.$http.post('richiestediquotazione/quotazione', data, {
              params: {
                codLang: this.codLang,
                country: this.form.country,
                codForn: this.form.codForn
              }
            })
              .then(response => {
                if (response.body.rc === 0) {
                  this.$message({
                    showClose: true,
                    message: response.body.msg[0].msgTxt,
                    type: 'success',
                    duration: process.env.duration
                  })
                  this.$router.push({name: 'RdQQuotazioni'})
                } else {
                  this.$message({
                    showClose: true,
                    message: response.body.msg[0].msgTxt,
                    type: 'error',
                    duration: process.env.duration
                  })
                  this.$set(this, 'loading', false)
                }
              })
          } else {
            this.goToNote(true)
          }
        }).catch(() => {
          //
        })
      },
      setStatusDoc: function (row) {
        if (row.statusDoc === 'N') {
          this.$set(this, 'loading', true)

          let data = {
            codSoc: this.quotazione.codSoc,
            codStab: this.quotazione.codStab,
            annoCar: moment(this.quotazione.data, 'DDMMYYYY').format('YYYY'),
            numRif: this.quotazione.numRif,
            tipoRich: this.testata.tipoRich,
            progressivo: row.progressivo,
            op: 'P',
            codTipoDoc: row.codTipoDoc
          }

          this.$http.post('richiestediquotazione/setstatusdoc', data, {
            params: {
              codLang: this.codLang,
              country: this.form.country,
              codForn: this.form.codForn
            }
          })
            .then(response => {
              if (response.body.rc === 0) {
                this.loadQuotazione(true)
              } else {
                this.$message({
                  showClose: true,
                  message: response.body.msg[0].msgTxt,
                  type: 'error',
                  duration: process.env.duration
                })
                this.$set(this, 'loading', false)
              }
            })
        }
      },
      changeNonPrevisti: function (newVal) {
        if (newVal) {
          this.$set(this.testata, 'oneriSic', '0,00')
        }
      },
      changeNonPrevistiAlt: function (newVal) {
        if (newVal) {
          this.$set(this.testata, 'oneriSicAlt', '0,00')
        }
      },
      changeNonPrevistiGen: function (newVal) {
        if (newVal) {
          this.$set(this, 'oneriSic', '0,00')
        }
      },
      changeRadio: function (newVal) {
        this.$set(this, 'loading', true)
        if (newVal === 'D') {
          this.deleteDocPreview()
          this.$set(this, 'ifUpload', false)
        }
        this.getTipoDoc()
      },
      getNote: function () {
        this.$http.get('richiestediquotazione/note', {
          params: {
            codLang: this.codLang,
            country: this.form.country
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              this.$set(this, 'formNote', response.body.data)
            } else {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
              this.$set(this, 'formNote', [])
            }
          })
      },
      getInterventi: function () {
        this.$http.get('richiestediquotazione/interventi', {
          params: {
            codLang: this.codLang,
            codForn: this.form.codForn,
            country: this.form.country,
            codSoc: this.quotazione.codSoc,
            codStab: this.quotazione.codStab,
            annoCar: moment(this.quotazione.data, 'DDMMYYYY').format('YYYY'),
            numRif: this.quotazione.numRif,
            pag_for: this.pag_for,
            pag_from: this.currentPage,
            pag_action: (this.currentPage === 1) ? 'BEGIN' : 'NEXT'
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              if (this.currentPage === 1) {
                this.$set(this, 'nrItems', parseInt(response.body.attrib.size))
                this.$set(this, 'nrPages', parseInt(response.body.attrib.pages))
              }
  
              let data = response.body.data
              data.forEach(intervento => {
                let tmp = JSON.parse(JSON.stringify(this.formInterventi))
                intervento.descEstesa = intervento.descEstesa.replace(/\\n/g, '\n')
                if (!this.formInterventi[intervento.codice]) {
                  tmp[intervento.codice] = intervento
                  tmp[intervento.codice].edit = false

                  let val = tmp[intervento.codice]['prezzo']
                  val = numeral(val.replace(/,/g, '.')).format('0,0.00')
                  val = val.replace(/\./g, '&').replace(/,/g, '.').replace('&', ',')
                  if (val === '0,00') {
                    val = ''
                  }
                  tmp[intervento.codice]['prezzo'] = val

                  let val_2 = tmp[intervento.codice]['prezzoAlt']
                  val_2 = numeral(val_2.replace(/,/g, '.')).format('0,0.00')
                  val_2 = val_2.replace(/\./g, '&').replace(/,/g, '.').replace('&', ',')
                  if (val_2 === '0,00') {
                    val_2 = ''
                  }
                  tmp[intervento.codice]['prezzoAlt'] = val_2

                  this.$set(this, 'formInterventi', tmp)
                } else {
                  let val = tmp[intervento.codice]['prezzo']
                  val = numeral(val.replace(/,/g, '.')).format('0,0.00')
                  val = val.replace(/\./g, '&').replace(/,/g, '.').replace('&', ',')
                  if (val === '0,00') {
                    val = ''
                  }
                  intervento.prezzo = val

                  let val_2 = tmp[intervento.codice]['prezzoAlt']
                  val_2 = numeral(val_2.replace(/,/g, '.')).format('0,0.00')
                  val_2 = val_2.replace(/\./g, '&').replace(/,/g, '.').replace('&', ',')
                  if (val_2 === '0,00') {
                    val_2 = ''
                  }
                  intervento.prezzoAlt = val_2

                  intervento.numSettCons = tmp[intervento.codice].numSettCons
                  intervento.nota = tmp[intervento.codice].nota
                }
              })
              this.$set(this, 'interventi', data)
            } else {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
            }

            this.$set(this, 'interventiLoading', false)
          })
      },
      changePage: function (page) {
        this.$set(this, 'interventiLoading', true)
        setTimeout(() => {
          this.$set(this, 'currentPage', page)
          this.getInterventi()
        }, 200)
      },
      openInterventi: function () {
        this.$set(this, 'interventiVisible', true)
        this.$set(this, 'interventiLoading', true)
        this.$set(this, 'interventi', [])
        this.$set(this, 'formInterventi', {})
        this.$set(this, 'importoProposta', '')
        this.$set(this, 'propostaAlternativa', '')

        this.$set(this, 'currentPage', 1)
        this.$set(this, 'nrPages', 0)
        this.$set(this, 'nrItems', 0)
        this.$set(this, 'importoProposta', '')
        this.$set(this, 'propostaAlternativa', '')

        // Chiamo il salvataggio con secondo parametro true per ricevere solo i totali di quanto già salvato e chiamare poi la lista interventi
        this.saveInterventi(false, true)
      },
      closeInterventi: function () {
        this.$set(this, 'loading', true)
        this.loadQuotazione(false, true)
      },
      changeRow: function (codice, campo) {
        this.$set(this, 'importoProposta', '')
        this.$set(this, 'propostaAlternativa', '')
        let tmp = JSON.parse(JSON.stringify(this.formInterventi))
        tmp[codice].edit = true
        this.$set(this, 'formInterventi', tmp)
        if (campo) {
          if (campo === 'prezzo') {
            this.$set(this.formInterventi[codice], 'prezzoAlt', '')
          } else if (campo === 'prezzoAlt') {
            this.$set(this.formInterventi[codice], 'prezzo', '')
          }
          this.onInputForm(codice, campo)
        }
      },
      onFocusForm: function (codice, campo) {
        let val = this.formInterventi[codice][campo].replace(/\./g, '')
        this.$set(this.formInterventi[codice], campo, val)
      },
      onInputForm: function (codice, campo) {
        let val = this.formInterventi[codice][campo].replace(/\./g, ',').replace(/\s/g, '').replace(/[^0-9,]/g, '')
        if (val) {
          if (val.indexOf(',') === 0) {
            val = '0' + val
          }
          if (val.length > 1 && val.startsWith('0') && !val.startsWith('0,')) {
            val = val.substring(1)
          }
          if (val.indexOf(',') !== val.lastIndexOf(',')) {
            let intero = val.substring(0, val.indexOf(','))
            let decimale = val.substring(parseInt(val.indexOf(',')) + 1).replace(/,/g, '')
            val = intero + ',' + decimale
          }
        }
        this.$set(this.formInterventi[codice], campo, val)
      },
      onBlurForm: function (codice, campo) {
        let val = this.formInterventi[codice][campo]
        val = numeral(val.replace(/,/g, '.')).format('0,0.00')
        val = val.replace(/\./g, '&').replace(/,/g, '.').replace('&', ',')
        if (val === '0,00') {
          val = ''
        }
        this.$set(this.formInterventi[codice], campo, val)
      },
      saveInterventi: function (ifClose, seSoloTotali) {
        this.$set(this, 'interventiLoading', true)

        let array = []
        for (let codice in this.formInterventi) {
          let el = JSON.parse(JSON.stringify(this.formInterventi[codice]))
          if (el.edit) {
            el.prezzo = el.prezzo.replace(/\./g, '')
            el.prezzoAlt = el.prezzoAlt.replace(/\./g, '')
            delete el['edit']
            delete el['qta']
            delete el['uMis']
            delete el['desc']
            array.push(el)
          }
        }

        if (array.length === 0 && !seSoloTotali) {
          this.$set(this, 'interventiLoading', false)
          return
        }

        let data = {
          numRif: this.quotazione.numRif,
          annoCar: moment(this.quotazione.data, 'DDMMYYYY').format('YYYY'),
          codSoc: this.quotazione.codSoc,
          codStab: this.quotazione.codStab,
          interventi: array
        }
        this.$http.post('richiestediquotazione/interventi', data, {
          params: {
            codLang: this.codLang,
            country: this.form.country,
            codForn: this.form.codForn
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              // Chiamata all'apertura della modal per ottenere i totali
              if (seSoloTotali) {
                let val = response.body.data.importoProp
                val = numeral(val.replace(/,/g, '.')).format('0,0.00')
                val = val.replace(/\./g, '&').replace(/,/g, '.').replace('&', ',')
                if (val === '0,00') {
                  val = ''
                }

                let val_2 = response.body.data.importoAlt
                val_2 = numeral(val_2.replace(/,/g, '.')).format('0,0.00')
                val_2 = val_2.replace(/\./g, '&').replace(/,/g, '.').replace('&', ',')
                if (val_2 === '0,00') {
                  val_2 = ''
                }

                this.$set(this, 'importoProposta', val)
                this.$set(this, 'propostaAlternativa', val_2)
                this.getInterventi()
              }
              // Salvataggi effettivi da bottone
              else {
                this.$message({
                  showClose: true,
                  message: response.body.msg[0].msgTxt,
                  type: 'success',
                  duration: process.env.duration
                })

                if (ifClose) {
                  this.$set(this, 'interventiLoading', false)
                  this.$set(this, 'interventiVisible', false)
                  // La chiamata al load quotazione viene gestita dall'evento @close della modal
                } else {
                  let val = response.body.data.importoProp
                  val = numeral(val.replace(/,/g, '.')).format('0,0.00')
                  val = val.replace(/\./g, '&').replace(/,/g, '.').replace('&', ',')
                  if (val === '0,00') {
                    val = ''
                  }

                  let val_2 = response.body.data.importoAlt
                  val_2 = numeral(val_2.replace(/,/g, '.')).format('0,0.00')
                  val_2 = val_2.replace(/\./g, '&').replace(/,/g, '.').replace('&', ',')
                  if (val_2 === '0,00') {
                    val_2 = ''
                  }

                  this.$set(this, 'importoProposta', val)
                  this.$set(this, 'propostaAlternativa', val_2)

                  for (let codice in this.formInterventi) {
                    let el = this.formInterventi[codice]
                    el.edit = false
                  }

                  this.getInterventi()
                }
              }
            } else {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })

              this.$set(this, 'interventiLoading', false)
            }
          })
      },
      formattedContent: function(text) {
        return text.replace(/\n/g, '<br>')
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
  @import "../../../assets/less/general.less";
  
  .salva-quotazioni {
    .el-message-box__content {
      padding: 15px 5px 25px 5px;
      .el-message-box__message {
        padding-left: 40px;
        padding-right: 0;
      }
    }
  }

  .modal-note {
    textarea {
      height: 180px;
    }
    .error-note {
      .set-font(@color: @rossoRiva, @size: 17px, @family: 'os-semibold');
      margin-bottom: 10px;
    }
  }

  .modal-interventi {
    .interventi-container {
      .interventi-label {
        .set-font(@family: 'os-semibolditalic', @color: @rossoRiva, @size: 15px);
        letter-spacing: 1px;
      }
      .interventi-value {
        .set-font(@family: 'os-semibold', @color: '#666', @size: 15px);
        margin-left: 15px;
      }
      .el-table {
        margin-top: 15px;
        margin-bottom: 15px;
        min-height: 380px;
        .input-wrapper {
          .el-input__inner {
            border: 1px solid #CCC !important;
            padding: 0 5px;
            text-align: right;
            letter-spacing: 0;
          }
        }
        .select-wrapper {
          .el-input__inner {
            border: 1px solid #CCC !important;
            padding: 0 5px;
            letter-spacing: 0;
          }
          .el-input__icon {
            margin-top: 1px;
          }
        }
      }
    }
  }

  .dettaglio-quotazione {
    .header-tab {
      height: 70px;
      text-align: center;
      margin-bottom: 5px;
      .back-div {
        line-height: 70px;
        text-align: left;
      }
      .back {
        color: @greenRiva;
      }
      .my-label {
        line-height: 55px;
        height: 45px;
        .set-font(@color: @oroRiva, @size: 21px, @family: 'os-semibolditalic');
        letter-spacing: 2px;
      }
      .sotto-label {
        .set-font(@color: @greenRiva, @size: 15px, @family: 'os-semibolditalic');
        letter-spacing: 1px;
      }
    }
    .sx {
      border-right: 1px solid #ccc;
      margin-bottom: 15px;
      .descrizione {
        .set-font(@color: @rossoRiva, @size: 15px, @family: 'os-semibold');
        letter-spacing: 1px;
        margin-bottom: 20px;
        .fa-icon {
          float: right;
        }
      }
      .testata-sx {
        margin-bottom: 20px;
        .elemento {
          margin-bottom: 5px;
          .testata-label {
            .set-font(@size: 11px, @color: @greenRiva, @family: 'os-semibold');
            text-align: right;
            line-height: 22px;
            overflow: hidden;
            text-overflow: ellipsis;
            text-transform: uppercase;
            letter-spacing: 1px;
          }
          .testata-value {
            .set-font(@size: 13px, @color: #666, @family: 'os-regular');
            line-height: 20px;
            letter-spacing: 1px;
            .custom-input {
              .el-input__inner {
                height: 22px !important;
                padding: 0 5px;
                border: 1px solid #dcdfe6;
              }
            }
            .custom-date-picker {
              .el-input__inner {
                width: 140px;
                height: 22px !important;
                padding-left: 30px !important;
                border: 1px solid #dcdfe6;
              }
              .el-input__inner:focus {
                border-color: @greenRiva;
              }
              .el-input__prefix {
                left: 0;
              }
            }
            .custom-select-el {
              .el-input__inner {
                height: 22px !important;
                line-height: 22px;
                border: 1px solid #dcdfe6;
                padding: 0 5px;
                letter-spacing: 0;
              }
              .is-disabled {
                .el-input__inner {
                  background-color: #f5f7fa;
                }
                .el-input__inner:hover {
                  border: 1px solid #dcdfe6 !important;
                }
              }
            }
          }
          .textarea {
            .el-textarea {
              textarea {
                height: 66px;
              }
            }
          }
          .consegna {
            .custom-input {
              .el-input__inner {
                width: 60px;
                height: 22px !important;
                padding: 0 5px;
                border: 1px solid #dcdfe6;
              }
            }
          }
          .consegna-label-dx {
            .set-font(@family: 'os-regular', @color: @greenRiva, @size: 11px);
            line-height: 22px;
            padding: 0 7px;
          }
        }
      }
      .testata-dx {
        margin-bottom: 20px;
        .elemento {
          margin-bottom: 5px;
          display: flex;
          justify-content: flex-start;
          margin-bottom: 35px;
          .testata-label {
            .set-font(@size: 11px, @color: @greenRiva, @family: 'os-semibold');
            line-height: 22px;
            overflow: hidden;
            text-overflow: ellipsis;
            text-transform: uppercase;
            letter-spacing: 1px;
            margin-right: 15px;
          }
          .testata-value {
            .custom-date-picker {
              .el-input__inner {
                width: 140px;
                height: 22px !important;
                padding-left: 30px !important;
                border: 1px solid #dcdfe6;
              }
              .el-input__inner:focus {
                border-color: @greenRiva;
              }
              .el-input__prefix {
                left: 0;
              }
            }
          }
        }
        .accetta-proposta {
          padding-right: 15px;
          text-align: right;
          .set-font(@family: 'os-semibold', @color: @rossoRiva, @size: 16px);
          height: 20px;
          line-height: 20px;
        }
        .el-radio-custom {
          text-align: right;
          .el-radio__input {
            float: right;
            margin-left: 10px;
          }
          .el-radio__label {
            .set-font(@family: 'os-semibold', @color: @rossoRiva, @size: 14px);
          }
          .el-radio__inner:hover {
            border-color: #666 !important;
          }
          .is-checked {
            color: #666;
            .el-radio__inner {
              background: #fff;
              border: 1px solid #666;
            }
            .el-radio__inner::after {
              background-color: #666;
              width: 7px;
              height: 7px;
            }
          }
        }
        .separatore-div {
          margin-top: 5px;
          height: 3px;
          margin-bottom: 10px;
          .separatore {
            border-top: 3px double @rossoRiva;
            height: 3px;
            width: 300px;
            float: right;
          }
        }
        .importo {
          display: flex;
          justify-content: flex-end;
          .my-label {
            .set-font(@family: 'os-semibolditalic', @color: @rossoRiva, @size: 16px);
            margin-right: 10px;
            line-height: 30px;
            text-align: right;
          }
          .custom-input {
            width: 135px;
            margin-right: 10px;
            .el-input__inner {
              height: 30px !important;
              line-height: 30px;
              padding: 0 5px;
              border: 1px solid #dcdfe6;
              text-align: right;
              letter-spacing: 0;
              .set-font(@color: black, @size: 18px, @family: 'os-semibold');
            }
          }
          .custom-select-el {
            width: 60px;
            .el-input__inner {
              height: 30px !important;
              line-height: 30px;
              border: 1px solid #dcdfe6;
              padding: 0 5px;
              letter-spacing: 0;
            }
            .is-disabled {
              .el-input__inner {
                background-color: #f5f7fa;
              }
              .el-input__inner:hover {
                border: 1px solid #dcdfe6 !important;
              }
            }
          }
        }
        .oneri-sicurezza {
          margin-top: 5px;
          display: flex;
          justify-content: flex-end;
          padding-left: 0;
          .my-label {
            .set-font(@family: 'os-semibolditalic', @color: #666, @size: 12px);
            margin-right: 10px;
            line-height: 30px;
            text-align: right;
          }
          .custom-input {
            width: 135px;
            margin-right: 10px;
            .el-input__inner {
              height: 30px !important;
              line-height: 30px;
              padding: 0 5px;
              border: 1px solid #dcdfe6;
              text-align: right;
              letter-spacing: 0;
              .set-font(@color: #666, @size: 15px, @family: 'os-regular');
            }
          }
          .non-previsti {
            width: 135px;
            margin-right: 10px;
            .custom-checkbox {
              padding: 0 !important;
              top: -4px;
              .el-checkbox__label {
                .set-font(@family: 'os-regular', @color: #666, @size: 11px);
                padding-left: 5px;
              }
            }
          }
          .divisa {
            width: 60px;
          }
        }
      }
      .button-interventi-div {
        display: flex;
        justify-content: flex-end;
        height: 0px;
        .button-interventi {
          letter-spacing: 1px;
          .set-font(@family: 'os-semibold', @color: @rossoRiva, @size: 13px);
          padding: 0 25px;
          height: 30px;
          z-index: 100;
        }
      }
      .tabs-documenti {
        margin-top: 5px;
        margin-bottom: 40px;
        &.tabs-spagna {
          .el-tabs__item {
            width: 290px !important;
            div {
              width: 290px !important;
            }
          }
        }
        .el-table {
          .el-table__header {
            .cell {
              &.header-add {
                padding: 0 !important;
              }
              .icona-add {
                color: @rossoRiva;
                float: right;
                font-size: 20px;
              }
            }
          }
          .el-table__body {
            .evidenziato {
              background-color: #daf5da;
            }
            .icone-div {
              display: flex;
              justify-content: flex-end;
              .icona {
                color: @rossoRiva;
                margin-left: 10px;
              }
              .icona-pv {
                color: #ccc;
                margin-left: 10px;
              }
            }
          }
        }
      }
    }
    .dx {
      margin-bottom: 15px;
      .titolo {
        .set-font(@color: #666, @size: 16px, @family: 'os-semibold');
        line-height: 16px;
      }
      .info-download {
        display: flex;
        justify-content: space-between;
        margin-top: 15px;
        .nome-doc {
          .set-font(@color: #ccc, @size: 16px, @family: 'os-semibolditalic');
          letter-spacing: 1px;
        }
      }
      .info-upload {
        display: flex;
        justify-content: space-between;
        margin-top: 15px;
        .custom-select-el {
          width: 240px;
        }
      }
      .nome-file {
        margin-top: 10px;
        height: 15px;
        line-height: 15px;
        .set-font(@color: #ccc, @size: 12px, @family: 'os-lightitalic');
      }
      .doc-container {
        // padding-top: 15px;
        .doc {
          height: 100%;
          width: 100%;
          border: 1px solid @grayMedium;
          border-style: dashed;
          .el-upload {
            display: block;
            margin: auto;
          }
          .add {
            margin-top: 20px;
            line-height: 30px;
            .add-icon {
              font-size: 35px;
              color: @rossoRiva;
            }
            .el-upload__text {
              .set-font(@size: 14px, @family: 'os-regular', @color: @rossoRiva);
            }
          }
        }
        .preview-img {
          height: 100%;
          width: 100%;
          border: 1px solid @grayMedium;
          border-style: dashed;
          img {
            display: block;
            margin-left: auto;
            margin-right: auto;
            max-width: 100%;
          }
        }
        .file-preview {
          height: 100%;
          width: 100%;
          border: 1px solid @grayMedium;
          border-style: dashed;
          position: relative;
          .delete {
            color: #666;
            position: absolute;
            top: 10px;
            right: 10px;
            z-index: 10;
          }
          canvas {
            height: 100% !important;
            width: unset !important;
            display: block !important;
            margin-left: auto;
            margin-right: auto;
            max-width: 100%;
          }
          img {
            display: block;
            margin-left: auto;
            margin-right: auto;
            max-width: 100%;
          }
        }
      }
    }
    .bottoni {
      text-align: right;
      margin-bottom: 15px;
    }
  }

  @media only screen and (max-width: 1249px) {
    .dettaglio-quotazione {
      .sx {
        border-right: 0 !important;
      }
    }
  }

  @media only screen and (max-width: 1000px) {
    .dettaglio-quotazione {
      .button-interventi-div {
        margin-bottom: 40px !important;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/Fornitura/RichiesteDiQuotazione/DettaglioQuotazione.vue